export default __webpack_public_path__ + "upload/leaf-top.b3269884.png";